import React from 'react';
import { Popover, Button, Typography, Divider } from 'antd';
import { BugTwoTone } from '@ant-design/icons';

import {
  useHasCompletedSurvey,
  useHasTrackingCode,
  usePrerenderUserId,
  useSelector,
} from '../../hooks/usePrerenderUser';
import { isUserTestingGroupA } from '../../features/OnboardingSurvey';
import { useSuggestedPlan } from '~features/billing';
import { dates } from '~library/dates';

const ENV = process.env.REACT_APP_STAGE;

function DebugContent() {
  const userid = usePrerenderUserId();
  const companyId = useSelector((state) => state.prerenderUser.companyId);
  const trackingCodeInstalled = useHasTrackingCode();
  const surveyCompleted = useHasCompletedSurvey();
  const hadTrialBefore = useSelector((state) => state.prerenderUser.hadTrialBefore);
  const trialEndsAt = useSelector((state) => state.prerenderUser.trialEndsAt);
  const isTrial = useSelector((state) => state.prerenderUser.isTrial);
  const recachingDisabled = useSelector((state) => state.prerenderUser.recachingDisabled);
  const cancelledAt = useSelector((state) => state.prerenderUser.cancelledAt);
  const suggestedPlan = useSuggestedPlan();

  return (
    <div>
      <Typography.Paragraph>
        (login) User ID: {userid} (Test Group {isUserTestingGroupA(userid) ? 'A' : 'B'})
      </Typography.Paragraph>
      <Typography.Paragraph>Company id: {companyId}</Typography.Paragraph>
      <Typography.Paragraph>Tracking code installed: {trackingCodeInstalled ? 'Yes' : 'No'}</Typography.Paragraph>
      <Typography.Paragraph>Survey completed: {surveyCompleted ? 'Yes' : 'No'}</Typography.Paragraph>
      <Divider>Free trial</Divider>
      <Typography.Paragraph>Had trial before: {hadTrialBefore ? 'Yes' : 'No'}</Typography.Paragraph>
      <Typography.Paragraph>Is trial: {isTrial ? 'Yes' : 'No'}</Typography.Paragraph>
      <Typography.Paragraph>
        Trial ends at: {trialEndsAt ? dates.dayOfPointInTime(trialEndsAt) : 'No trial'}
      </Typography.Paragraph>
      <Divider>Subscription</Divider>
      <Typography.Paragraph>
        Suggested plan: {suggestedPlan ? `${suggestedPlan.name} (${suggestedPlan.id})` : 'No suggested plan'}
      </Typography.Paragraph>
      <Typography.Paragraph>Recaching disabled: {recachingDisabled ? 'Yes' : 'No'}</Typography.Paragraph>
      <Typography.Paragraph>
        Status: {cancelledAt ? 'cancel date ' + dates.dayOfPointInTime(cancelledAt) : 'active'}
      </Typography.Paragraph>
    </div>
  );
}

function DebugMenu() {
  if (ENV === 'production') {
    return null;
  }

  return (
    <Popover content={DebugContent} title="Debugging data" trigger="click">
      <Button icon={<BugTwoTone />} color="default" variant="dashed">
        Debug data
      </Button>
    </Popover>
  );
}

export default DebugMenu;
